/* eslint-disable */
export default {
  attachFiles: '附加檔案',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
